import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useData } from "../contexts/DataContext";

const NavbarPag = () => {
  const { setOd, setProfile, setRutInit, profile } = useData();
  const navigate = useNavigate();
  const location = useLocation();
  const [adminOpen, setAdminOpen] = useState(false);

  const handleNavigate = (path: string) => {
    setAdminOpen(false);
    navigate(path, {
      state: {
        email: location.state?.email,
        name: location.state?.name,
      },
    });
  };

  const handleLogout = () => {
    setAdminOpen(false);
    setProfile("");
    setRutInit("");
    setOd("");
    navigate("/", { replace: true });
  };

  const isAdmin = profile !== "" && profile !== undefined;

  return (
    <nav className="w-full bg-[#0084C7] px-6 lg:px-16 flex items-center justify-between h-14 shadow-md flex-shrink-0">
      {/* Logo */}
      <span
        className="text-white font-bold text-lg cursor-pointer tracking-wide"
        onClick={() => handleNavigate("/dashboard")}
      >
        SCB EXPRESS
      </span>

      {/* Links */}
      <ul className="hidden md:flex items-center gap-6 text-sm">
        <li
          className="text-white hover:text-blue-200 cursor-pointer transition-colors"
          onClick={() => { setOd(""); handleNavigate("/workOrder"); }}
        >
          Crear orden
        </li>
        <li
          className="text-white hover:text-blue-200 cursor-pointer transition-colors"
          onClick={() => { setOd(""); handleNavigate("/dashboard"); }}
        >
          Orden excel
        </li>
        <li
          className="text-white hover:text-blue-200 cursor-pointer transition-colors"
          onClick={() => { setOd(""); handleNavigate("/search"); }}
        >
          Consultar
        </li>
        <li
          className="text-white hover:text-blue-200 cursor-pointer transition-colors"
          onClick={() => handleNavigate("/searchOD")}
        >
          Consultar OD
        </li>
        {!isAdmin && (
          <li
            className="text-white hover:text-blue-200 cursor-pointer transition-colors"
            onClick={() => handleNavigate("/clientDocuments")}
          >
            Mis Documentos
          </li>
        )}
        <li
          className="text-white hover:text-blue-200 cursor-pointer transition-colors"
          onClick={() => { setOd(""); handleNavigate("/Reporte"); }}
        >
          Reporte de envíos
        </li>

        {/* Admin dropdown */}
        {isAdmin && (
          <li className="relative">
            <button
              onClick={() => setAdminOpen(!adminOpen)}
              className="flex items-center gap-1 text-white hover:text-blue-200 transition-colors text-sm font-medium bg-blue-700 hover:bg-blue-600 px-3 py-1 rounded"
            >
              Admin
              <svg
                className={`w-3 h-3 transition-transform ${adminOpen ? "rotate-180" : ""}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {adminOpen && (
              <>
                {/* overlay para cerrar al hacer click fuera */}
                <div
                  className="fixed inset-0 z-10"
                  onClick={() => setAdminOpen(false)}
                />
                <ul className="absolute right-0 top-full mt-1 bg-white rounded-lg shadow-lg border border-gray-100 w-48 z-20 py-1">
                  <li
                    className="px-4 py-2 text-gray-700 hover:bg-gray-50 cursor-pointer text-sm"
                    onClick={() => handleNavigate("/controlRutas")}
                  >
                    Control Rutas
                  </li>
                  <li
                    className="px-4 py-2 text-gray-700 hover:bg-gray-50 cursor-pointer text-sm"
                    onClick={() => handleNavigate("/RegisterUser")}
                  >
                    Registrar Usuario
                  </li>
                  <li
                    className="px-4 py-2 text-gray-700 hover:bg-gray-50 cursor-pointer text-sm"
                    onClick={() => handleNavigate("/AdminOd")}
                  >
                    Administrar OD
                  </li>
                  <li
                    className="px-4 py-2 text-gray-700 hover:bg-gray-50 cursor-pointer text-sm"
                    onClick={() => handleNavigate("/adminUpload")}
                  >
                    Subir Documentos
                  </li>
                  <li
                    className="px-4 py-2 text-gray-700 hover:bg-gray-50 cursor-pointer text-sm"
                    onClick={() => handleNavigate("/adminClients")}
                  >
                    Gestionar Clientes
                  </li>
                </ul>
              </>
            )}
          </li>
        )}

        {/* Cerrar sesión (admin y cliente) */}
        <li>
          <button
            onClick={handleLogout}
            className="flex items-center gap-1 text-white hover:text-blue-100 transition-colors text-sm font-medium bg-red-600 hover:bg-red-700 px-3 py-1 rounded"
          >
            Cerrar sesión
          </button>
        </li>
      </ul>

      {/* Hamburger mobile */}
      <div className="space-y-1 group md:hidden">
        <div className="w-6 h-0.5 bg-white"></div>
        <div className="w-6 h-0.5 bg-white"></div>
        <div className="w-6 h-0.5 bg-white"></div>
        <ul className="bg-[#252525] w-screen pb-10 absolute -top-full group-focus:top-0 right-0 duration-150 flex flex-col space-y-3 justify-end">
          <button className="px-10 py-8 relative ml-auto">
            <div className="w-6 h-1 rotate-45 absolute bg-white"></div>
            <div className="w-6 h-1 -rotate-45 absolute bg-white"></div>
          </button>
          <li className="flex text-white justify-center w-full py-4 hover:bg-[#202020]">
            Consultar
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavbarPag;
